import { render, staticRenderFns } from "./VNodes.vue?vue&type=template&id=4336e52f&"
import script from "./VNodes.vue?vue&type=script&lang=ts&"
export * from "./VNodes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4336e52f')) {
      api.createRecord('4336e52f', component.options)
    } else {
      api.reload('4336e52f', component.options)
    }
    module.hot.accept("./VNodes.vue?vue&type=template&id=4336e52f&", function () {
      api.rerender('4336e52f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/VNodes/VNodes.vue"
export default component.exports